import { OAuthModuleConfig } from 'angular-oauth2-oidc';
import { environment } from '../../environments/environment';

export const AuthentificationModuleConfig: OAuthModuleConfig = {
  resourceServer: {
    allowedUrls: [environment.servers.resources.url],
    sendAccessToken: true,
  },
};
